import { render } from "./categoryCourses.vue?vue&type=template&id=94fd9af2"
import script from "./categoryCourses.vue?vue&type=script&lang=js"
export * from "./categoryCourses.vue?vue&type=script&lang=js"

import "./categoryCourses.vue?vue&type=style&index=0&id=94fd9af2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__